import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SelectLetterTargetsModalComponent } from './select-letter-targets-modal.component';
import { SelectLetterTargetsComponent } from './select-letter-targets.component';

import { SelectLetterTargetsModalService } from './select-letter-targets.service';

import { SelectLetterTargetsStudentParentTabModule } from './components/student-parent-tab/student-parent-tab.module';
import { SelectLetterTargetsFacultyTabModule } from './components/faculty-tab/faculty-tab.module';
import { SelectLetterTargetsAdminOrAllModule } from './components/admin-or-all/admin-or-all.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ngfModule } from 'angular-file';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslationModule } from '@schoolbelle/common/translation';
import { SelectLetterTargetsRoutingModule } from './select-letter-targets-routing.module';
import { TableSearchModule } from './components/table-search/table-search.module';

@NgModule({
  imports: [
    CommonModule,
    SelectLetterTargetsStudentParentTabModule, 
    SelectLetterTargetsFacultyTabModule,
    SelectLetterTargetsAdminOrAllModule,
    ngfModule,
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    TranslationModule.forRoot(),

    SelectLetterTargetsRoutingModule,
    TableSearchModule,
    
  ],
  providers: [SelectLetterTargetsModalService],
  declarations: [SelectLetterTargetsComponent, SelectLetterTargetsModalComponent],
  entryComponents: [SelectLetterTargetsModalComponent],
  
})
export class SelectLetterTargetsModule { }
